import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { ActionResultOptions, CustomSelect, LogLevelOptions } from "../../../../../../_helpers/Helpers";
import { useSystemLogsUIContext } from "../SystemLogsUIContext";

const prepareFilter = (queryParams, values) => {
  let { schoolName, userName, message, level, timestamp } = values;
  const newQueryParams = { ...queryParams };
  const filter = { schoolName, userName, message, level, timestamp };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SystemLogsFilter() {
  // System Logs UI Context
  const systemLogsUIContext = useSystemLogsUIContext();
  const syetemLogsUIProps = useMemo(() => {
    return {
      queryParams: systemLogsUIContext.queryParams,
      setQueryParams: systemLogsUIContext.setQueryParams
    };
  }, [systemLogsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(syetemLogsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, syetemLogsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      syetemLogsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        schoolName: "",
        userName: "",
        message: "",
        timestamp: "",
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="schoolName"
                placeholder="Okul Adı"
                onBlur={handleBlur}
                value={values.schoolName}
                onChange={(e) => {
                  setFieldValue("schoolName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Okul Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="userName"
                placeholder="Kullanıcı Adı"
                onBlur={handleBlur}
                value={values.userName}
                onChange={(e) => {
                  setFieldValue("userName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="message"
                placeholder="Message"
                onBlur={handleBlur}
                value={values.message}
                onChange={(e) => {
                  setFieldValue("message", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Message</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={LogLevelOptions}
                value={values.level}
                placeholder="Level"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("level", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Level</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="timestamp"
                placeholder="Tarih"
                onBlur={handleBlur}
                value={values.timestamp}
                onChange={(e) => {
                  setFieldValue("timestamp", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tarih</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={ActionResultOptions}
                value={values.isSuccess}
                placeholder="Sonuç"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isSuccess", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sonuç</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}